import * as yup from "yup";

const DEFAULT_MSG = "Este campo es requerido."

const headerSchema = yup.object().shape({
    templateId:  yup.number().moreThan(0,"Seleccione un template.").required(DEFAULT_MSG),
});

export {
    headerSchema
}